import { MessageCircle } from "lucide-react";
import { useSiteSettings } from "@/hooks/use-site-settings";
import { whatsappLink } from "@/lib/site-settings";

const WhatsAppFloat = () => {
  const { settings } = useSiteSettings();
  const href = whatsappLink(settings.whatsapp_primary, settings.whatsapp_message);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <span className="relative flex h-14 w-14 min-h-11 min-w-11 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform duration-200 group-hover:scale-110">
        <MessageCircle className="h-7 w-7" fill="currentColor" strokeWidth={0} />
      </span>
    </a>
  );
};

export default WhatsAppFloat;
